import { render, staticRenderFns } from "./ToggleSectionSlide.vue?vue&type=template&id=08671e99&"
import script from "./ToggleSectionSlide.vue?vue&type=script&lang=js&"
export * from "./ToggleSectionSlide.vue?vue&type=script&lang=js&"
import style0 from "./ToggleSectionSlide.vue?vue&type=style&index=0&id=08671e99&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports